import src from "IMAGE";
export default { src, width: 313, height: 852, blurWidth: 0, blurHeight: 0};
